import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const Spinner = ({className, small}) => {
  const cls = [className, styles.spinner, small ? styles.small : undefined]

  return (
    <svg className={cls.join(' ')} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
      <circle cx="50" cy="50" fill="none" strokeWidth="8" r="40" strokeDasharray="164.93361431346415 56.97787143782138">
        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
      </circle>
    </svg>
  )
}

Spinner.propTypes = {
  className: PropTypes.string,
  small: PropTypes.bool,
}

Spinner.defaultProps = {
  className: '',
  small: false
}

export default Spinner

